import { Component, Input } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { DisputeCaseType } from "src/app/shared/models/dispute-resolution/dispute-base-models";

@Component({
  selector: "app-address-input",
  templateUrl: "./address-input.component.html",
  styleUrls: ["./address-input.component.scss"],
  standalone: false,
})
export class AddressInputComponent {
  @Input() parentForm: FormGroup;
  @Input() prefix: string = "";
  @Input() caseType: DisputeCaseType = DisputeCaseType.None;
  @Input() showPopulateCheckbox: boolean = false;
  @Input() sourcePrefix: string = "filer"; // The prefix of the address to copy from
  @Input() populateCheckboxLabel: string = "Populate Address from Above";

  populateFromAbove: boolean = false;
  
  // Expose enum for template use
  DisputeCaseType = DisputeCaseType;

  getControl(controlName: string) {
    return this.parentForm?.get(this.prefix + controlName);
  }

  isRequired(controlName: string): boolean {
    return this.getControl(controlName)?.hasValidator(Validators.required) ?? false;
  }

  onPopulateAddressChange(checked: boolean) {
    this.populateFromAbove = checked;
    
    if (checked) {
      // Copy address from source prefix to current prefix
      const sourceStreet1 = this.parentForm?.get(this.sourcePrefix + 'Street1')?.value || '';
      const sourceStreet2 = this.parentForm?.get(this.sourcePrefix + 'Street2')?.value || '';
      const sourceCity = this.parentForm?.get(this.sourcePrefix + 'City')?.value || '';
      const sourceState = this.parentForm?.get(this.sourcePrefix + 'State')?.value || '';
      const sourceZip = this.parentForm?.get(this.sourcePrefix + 'Zip')?.value || '';

      this.parentForm?.get(this.prefix + 'Street1')?.setValue(sourceStreet1);
      this.parentForm?.get(this.prefix + 'Street2')?.setValue(sourceStreet2);
      this.parentForm?.get(this.prefix + 'City')?.setValue(sourceCity);
      this.parentForm?.get(this.prefix + 'State')?.setValue(sourceState);
      this.parentForm?.get(this.prefix + 'Zip')?.setValue(sourceZip);
    } else {
      // Clear the address fields
      this.parentForm?.get(this.prefix + 'Street1')?.setValue('');
      this.parentForm?.get(this.prefix + 'Street2')?.setValue('');
      this.parentForm?.get(this.prefix + 'City')?.setValue('');
      this.parentForm?.get(this.prefix + 'State')?.setValue('');
      this.parentForm?.get(this.prefix + 'Zip')?.setValue('');
    }
  }
}
